import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from './firebase';
import './CategoryPage.css';

function FinancialCategory({ onNavigate, onClose }) {
  const [showWebmail, setShowWebmail] = useState(false);

  useEffect(() => {
    checkEmailConfig();
  }, []);

  const checkEmailConfig = async () => {
    try {
      const user = auth.currentUser;
      const franchiseeRef = doc(db, 'Franchisees', user.uid);
      const franchiseeDoc = await getDoc(franchiseeRef);
      if (franchiseeDoc.exists()) {
        const data = franchiseeDoc.data();
        const isBacre8Email = 
          data.useEmailService === true &&
          data.username &&
          data.username.toLowerCase().endsWith('@bacre8.co.za');
        setShowWebmail(isBacre8Email);
      }
    } catch (error) {
      console.error('Error checking email config:', error);
    }
  };

  return (
    <div className="category-page-container">
      <div className="category-page-header">
        <button onClick={onClose} className="back-button">
          ← Back to Dashboard
        </button>
        <div className="category-page-title">
          <span className="category-page-icon">💳</span>
          <h1>Financial Operations</h1>
        </div>
      </div>

      <div className="category-page-content">
        <div className="action-grid">
          <button className="action-card card-orange" onClick={() => onNavigate('statementGeneration')}>
            <span className="action-icon">📄</span>
            <span className="action-text">Generate Statements</span>
          </button>

          <button className="action-card card-orange" onClick={() => onNavigate('addBulkFees')}>
            <span className="action-icon">📦</span>
            <span className="action-text">Add Fees</span>
          </button>

          <button className="action-card card-red" onClick={() => onNavigate('outstandingFees')}>
            <span className="action-icon">💰</span>
            <span className="action-text">Outstanding Fees Report</span>
          </button>

          <button className="action-card card-blue" onClick={() => onNavigate('monthEndProcessing')}>
            <span className="action-icon">📅</span>
            <span className="action-text">Month-End Processing</span>
          </button>

          <button className="action-card card-indigo" onClick={() => onNavigate('viewMonthEndSubmissions')}>
            <span className="action-icon">📋</span>
            <span className="action-text">View Month-End Submissions</span>
          </button>

          <button className="action-card card-purple" onClick={() => alert('Coming soon!')}>
            <span className="action-icon">📜</span>
            <span className="action-text">Payment History</span>
          </button>

          {/* Webmail button - only shows for bacre8.co.za email accounts */}
          {showWebmail && (
            <button
              className="action-card card-teal"
              onClick={() => window.open('https://bacre8.co.za/webmail', '_blank')}
            >
              <span className="action-icon">📬</span>
              <span className="action-text">Access My Emails</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default FinancialCategory;